import { Injectable } from '@angular/core';
import { ExamdojoSupabaseService } from '@examdojo/supabase';
import { from } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ClassStudentHttpService {
  constructor(private readonly supabase: ExamdojoSupabaseService) {}

  fetchByClassId(classId: string) {
    return from(
      this.supabase.client
        .schema('classroom')
        .from('class_students_with_users')
        .select('*')
        .eq('class_id', classId)
        .throwOnError()
        .then((response) => response.data!),
    );
  }

  removeStudent(classId: string, studentId: string) {
    return from(
      this.supabase.client
        .schema('classroom')
        .from('class_students')
        .update({ removed_at: new Date().toISOString() })
        .eq('class_id', classId)
        .eq('student_id', studentId)
        .throwOnError()
        .then(() => undefined),
    );
  }
}
